import Vue from "vue";

Vue.mixin({
  methods: {

  }
});
